import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/ui/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/ui/header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/redux/storeProvider.tsx");
